<template>
  <div class="stlFilterGroup" :class="{ 'is-open': isOpen, 'is-mobile': isMobile }">
    <button
      type="button"
      class="stlFilterTrigger"
      :class="{ active: selectedOptions.length > 0 }"
      :aria-expanded="isOpen ? 'true' : 'false'"
      @click="$emit('toggle-open', group.type)"
    >
      <span class="stlFilterTriggerLabel">{{ groupName(group.type) }}</span>
      <span v-if="selectedOptions.length" class="stlFilterTriggerCount">{{ selectedOptions.length }}</span>
      <svg class="stlFilterTriggerIcon" viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
        <polyline points="6 9 12 15 18 9" />
      </svg>
    </button>

    <div v-if="isOpen" class="stlFilterDropdown">
      <div class="stlFilterDropdownScroll">
        <button
          v-for="tag in group.tags"
          :key="tag.id"
          type="button"
          class="stlFilterOption"
          :class="tagClasses(tag)"
          :style="tagStyle(tag)"
          :aria-label="tag.value"
          @click="$emit('toggle', tag.id)"
        >
          <span class="stlFilterOptionMain">
            <span v-if="tagColor(tag)" class="stlFilterColorBadge" />
            <span v-else class="stlFilterOptionLabel">{{ tag.value }}</span>
            <span v-if="tagColor(tag)" class="stlFilterOptionLabel">{{ tag.value }}</span>
          </span>
          <span v-if="isSelected(tag.id)" class="stlFilterOptionCheck" aria-hidden="true">&#10003;</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ShopTheLookFilterGroup',
  props: {
    group: {
      type: Object,
      required: true
    },
    selectedTagIds: {
      type: Array,
      default () {
        return []
      }
    },
    isOpen: {
      type: Boolean,
      default: false
    },
    isMobile: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    selectedOptions () {
      return (this.group.tags || []).filter(tag => this.isSelected(tag.id))
    }
  },
  methods: {
    isSelected (tagId) {
      return this.selectedTagIds.indexOf(Number(tagId)) >= 0
    },
    tagColor (tag) {
      const meta = String(tag.meta || '').trim()
      if (!meta) {
        return ''
      }

      const match = meta.match(/#(?:[0-9a-fA-F]{3}|[0-9a-fA-F]{6}|[0-9a-fA-F]{8})\b/)
      return match ? match[0] : ''
    },
    tagClasses (tag) {
      const classNames = []
      const meta = String(tag.meta || '').trim()

      if (this.isSelected(tag.id)) {
        classNames.push('active')
      }

      if (!meta) {
        return classNames
      }

      const color = this.tagColor(tag)
      const metaParts = meta.split(/\s+/)

      for (let i = 0; i < metaParts.length; i++) {
        if (metaParts[i] !== '' && metaParts[i] !== color) {
          classNames.push(metaParts[i])
        }
      }

      if (color) {
        classNames.push('hasColorBadge')
      }

      return classNames
    },
    tagStyle (tag) {
      const color = this.tagColor(tag)
      if (!color) {
        return null
      }

      return {
        '--stl-filter-color': color
      }
    },
    groupName (name) {
      if (this.group && typeof this.group.label === 'string' && this.group.label.trim() !== '') {
        return this.group.label
      }
      if (name === 'color') return this.$translate('STL::Template.filterGroupColor')
      if (name === 'wood') return this.$translate('STL::Template.filterGroupWood')
      if (name === 'wallcolor') return this.$translate('STL::Template.filterGroupWallcolor')
      if (name === 'series') return this.$translate('STL::Template.filterGroupSeries')
      if (name === 'room') return this.$translate('STL::Template.filterGroupRoom')
      if (name === 'category') return this.$translate('STL::Template.filterGroupCategory')
      if (name === 'brand') return this.$translate('STL::Template.filterGroupBrand')
      return name
    }
  }
}
</script>
